import styled from 'styled-components';
import * as UIConstants from '../../../UIConstants'

export const Wrapper = styled.div`
width: 100%;
box-sizing: border-box;
`;

export const Container = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: column wrap;
align-items: flex-start;
justify-content: flex-start;
`;

export const DisableButton = styled.div`
font-weight:400;
${UIConstants.mobileView}{
    font-size:12px;
}
`
export const ModalWrapper = styled.div`
// width:100%;
padding:20px 50px 10px 50px;
`
export const ModalImg = styled.div`

`
export const ModalMessege = styled.h2`

`
export const ModalAction = styled.h2`
 display:flex;
 justify-content:flex-end;
 gap:5px;
`

export const Delevered = styled.span`
padding: 4px 10px 5px 10px;
width: 53px;
height: 20px;
background: rgba(33, 150, 83, 0.1);
border: 1px solid #219653;
border-radius: 4px;
font-size: 12px;
color: #219653;
`;
export const Shipping = styled.span`
padding: 4px 10px 5px 10px;
width: 53px;
height: 20px;
background: silver;
border: 1px solid #003459;
border-radius: 4px;
font-size: 12px;
color: #003459;
`;

export const Received = styled.span`
padding: 5px 11px 6px 11px;

width: 53px;
height: 20px;
background: rgba(168, 171, 209, 0.8);
border: 1px solid #003459;
border-radius: 4px;
font-size: 12px;
color: #003459;
`;